module.exports = __webpack_public_path__ + "img/osago-arrow.c4022cc.webp";